import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthHttp } from 'angular2-jwt';
import { RequestOptions, Headers } from '@angular/http';
import { List } from 'immutable';
import { ResponseUtil } from '../../shared/utils/response-util';
import { Rsvp } from '../models/rsvp';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';

@Injectable()
export class RsvpHttpService {

  private eventsUrl: string = this.environment.baseUrl + '/api/events';

  constructor(private http: AuthHttp,
              private environment: EnvironmentConfiguration) {
  }

  getRsvps(eventId: number): Observable<List<Rsvp>> {
    return this.http.get(`${this.eventsUrl}/${eventId}/rsvps`)
      .map(response => List<Rsvp>(response.json().map(rsvpObject => new Rsvp(rsvpObject))))
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  add(rsvp: Rsvp): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    const rsvpAsJSON = JSON.stringify(rsvp.toJS());
    return this.http.post(`${this.eventsUrl}/rsvps`, rsvpAsJSON, options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  delete(rsvp: Rsvp): Observable<any> {
    return this.http.delete(`${this.eventsUrl}/rsvps/${rsvp.eventRsvpId}`)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  importRsvpViaCsv(eventId: number, file: File): Observable<any> {
    let formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.eventsUrl}/${eventId}/rsvps/csv`, formData)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/rsvp.http.service.ts